/**
 * Product Rating Number
 * VERSION: 1.0
 *
 * Judge.me's review badge (.jdgm-prev-badge) is injected entirely by their
 * own app script — there's no Liquid hook for it in this theme. It sets a
 * data-average-rating attribute (e.g. "4.90") on the badge once rendered,
 * but doesn't show that number anywhere itself — only the stars + review
 * count. This inserts a formatted "4.9"-style number before the stars,
 * colored to match them.
 *
 * Runs on product pages only (included conditionally in theme.liquid).
 * Uses a MutationObserver since Judge.me renders its widget async, some
 * time after this script itself loads.
 */
(function () {
  'use strict';

  // The "TESTIMONIALS" carousel further down the page is the Judge.me
  // review_widget app block. Its Shopify block id (shopify-block-...) is
  // different on every alternate product template (product.json,
  // product.pigment_paste_general.json, product.molds-1.json, etc — this
  // store has ~18 of them), so we can't hardcode one id. Instead, look for
  // Judge.me's own widget markup directly, which is the same regardless of
  // which template/block-id wraps it.
  var REVIEWS_SELECTORS = [
    '.jdgm-title',
    '[id^="shopify-block-judge_me_reviews_review_widget"]',
    '[id^="shopify-block-judge-me-reviews-review-widget"]',
    '.jdgm-rev-widg',
    '#judgeme_product_reviews'
  ];

  function findReviewsTarget() {
    for (var i = 0; i < REVIEWS_SELECTORS.length; i++) {
      var el = document.querySelector(REVIEWS_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function getStickyHeaderHeight() {
    // .site-header is sticky in this theme (gets .site-header--stuck once
    // scrolled); scrollIntoView's default alignment puts the target flush
    // with the viewport top, which then hides right under it. Offset by
    // its live rendered height instead of a hardcoded guess.
    var header = document.querySelector('.site-header');
    var height = header ? header.getBoundingClientRect().height : 0;
    return height + 20; // small breathing room below the header
  }

  function scrollToReviews(e) {
    // Judge.me's own badge markup may already wrap this in <a href="#">.
    // Stop that default jump-to-top regardless of whether we find our
    // target, so a bad selector fails silently instead of yanking the
    // page to the top.
    if (e && e.preventDefault) e.preventDefault();

    var target = findReviewsTarget();
    if (!target) return;

    var targetTop = target.getBoundingClientRect().top + window.pageYOffset;
    var scrollTo = targetTop - getStickyHeaderHeight();

    window.scrollTo({ top: Math.max(scrollTo, 0), behavior: 'smooth' });
  }

  function addRatingNumber(badge) {
    if (badge.dataset.ratingNumberAdded === 'true') return;

    var raw = badge.getAttribute('data-average-rating');
    var rating = raw ? parseFloat(raw) : NaN;
    if (!raw || isNaN(rating) || rating <= 0) return;

    var span = document.createElement('span');
    span.className = 'jdgm-rating-number';
    span.textContent = rating.toFixed(1);
    badge.insertBefore(span, badge.firstChild);
    badge.dataset.ratingNumberAdded = 'true';

    // Make the whole badge act as a link down to the testimonials block.
    // The reviews widget usually renders slightly after the badge does, so
    // don't require it to already exist — bind the click either way and
    // just no-op (scrollToReviews) if it's still not there when clicked.
    badge.classList.add('jdgm-prev-badge--linked');
    badge.addEventListener('click', scrollToReviews);
  }

  function scan() {
    document.querySelectorAll('.jdgm-prev-badge[data-average-rating]').forEach(addRatingNumber);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  var observer = new MutationObserver(function () {
    scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
